import { useEffect, useState } from 'react';
import { Form } from 'antd';

const vacias = [];
const normalizarNombre = valor => String(valor ?? '').trim().toLocaleLowerCase('es');
export const resolverUbicacion = (lista, valor) => {
  if (valor == null || valor === '') return null;
  const porId = lista.find(item => String(item.id) === String(valor));
  if (porId) return porId;
  const coincidencias = lista.filter(item => normalizarNombre(item.nombre) === normalizarNombre(valor));
  return coincidencias.length === 1 ? coincidencias[0] : null;
};

export default function useCiudadesTraslado(form, lado, departamentos, fetchCiudades, cache, reglas) {
  const campoDepartamento = `${lado}_departamento`;
  const campoCiudad = `${lado}_ciudad`;
  const departamento = Form.useWatch(campoDepartamento, { form, preserve: true });
  const ciudad = Form.useWatch(campoCiudad, { form, preserve: true });
  const departamentoId = resolverUbicacion(departamentos, departamento)?.id ?? null;
  const [resultado, setResultado] = useState({ departamentoId: null, ciudades: vacias });
  const ciudades = resultado.departamentoId === departamentoId ? resultado.ciudades : (cache?.current[departamentoId] ?? vacias);

  useEffect(() => {
    // undefined: permisos aún pendientes (o consumidor sin filtro). null: no configurada.
    const fuera = reglas === null || (reglas && departamentos.length > 0 &&
      (departamentoId == null || !reglas.departamentos.includes(Number(departamentoId))));
    if (fuera) {
      if (departamento != null || ciudad != null) form.setFieldsValue({ [campoDepartamento]: null, [campoCiudad]: null });
      return;
    }
    if (departamentoId != null && departamento !== departamentoId) form.setFieldValue(campoDepartamento, departamentoId);
  }, [departamentoId, departamento, ciudad, campoDepartamento, campoCiudad, departamentos, reglas, form]);

  useEffect(() => {
    let vigente = true;
    if (departamentoId == null) {
      setResultado({ departamentoId: null, ciudades: vacias });
      return;
    }
    fetchCiudades(departamentoId).then(datos => {
      if (vigente) {
        const ciudades = Array.isArray(datos) ? datos : [];
        if (cache) cache.current[departamentoId] = ciudades;
        setResultado({ departamentoId, ciudades });
      }
    });
    return () => { vigente = false; };
  }, [departamentoId, fetchCiudades, cache]);

  useEffect(() => {
    if (departamentoId == null || resultado.departamentoId !== departamentoId) return;
    const seleccionada = resolverUbicacion(ciudades, ciudad);
    const permitida = seleccionada && Number(seleccionada.departamento_id) === Number(departamentoId) &&
      (reglas === undefined || (reglas && reglas.departamentos.includes(Number(departamentoId)) &&
        (reglas.modo === 'todas' || reglas.ciudades.includes(Number(seleccionada.id)))));
    if (reglas !== undefined && !permitida) {
      if (ciudad != null) form.setFieldValue(campoCiudad, null);
      return;
    }
    if (seleccionada && ciudad !== seleccionada.id) form.setFieldValue(campoCiudad, seleccionada.id);
  }, [ciudades, ciudad, departamentoId, resultado.departamentoId, campoCiudad, reglas, form]);

  return ciudades;
}
